import type { AmcStatus } from "./api";

/**
 * AMC badge presentation.
 *
 * Tone is always paired with an explicit label, never colour alone — a
 * red/green pill is unreadable to the ~8% of men with colour-vision
 * deficiency, and AMC expiry drives renewal revenue.
 */
export function amcBadge(
  status: AmcStatus,
  days: number | null,
): { tone: "muted" | "success" | "danger" | "warning"; label: string } {
  switch (status) {
    case "expired":
      return {
        tone: "danger",
        label: days === null ? "Expired" : `Expired ${Math.abs(days)}d ago`,
      };
    case "expiring_soon":
      return {
        tone: "warning",
        label: days === 0 ? "Expires today" : `Expires in ${days}d`,
      };
    case "active":
      return { tone: "success", label: "Active" };
    default:
      return { tone: "muted", label: "No AMC" };
  }
}
